import { Axios } from './../shared/Axios';
import qs from 'qs';
import { saveAs } from "file-saver";
import moment from 'moment';

class DashboardService extends Axios {

    private static instance: DashboardService;

    static get(): DashboardService {
        if (!DashboardService.instance) {
            DashboardService.instance = new DashboardService();
        }
        return DashboardService.instance;
    }

    async getDashboard(data: object): Promise<any> {

        return this.instance.get(`/admin/dashboard${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async exportTransaction(data: object): Promise<any> {

        const response: any = await this.instance.get(`/admin/dashboard/export${qs.stringify(data, { addQueryPrefix: true })}`, {
            responseType: "arraybuffer"
        })
        // Create a Blob from the response data
        const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        // Save the file using FileSaver
        saveAs(blob, `Report_${moment().format('DD-MM-YYYY_HH:mm')}.xlsx`);

        return response;


    }




}


const dashboardService = DashboardService.get();

export { dashboardService as DashboardService }